import React from 'react';

const TuitionPlansPage = React.lazy(() => import('./TuitionPlansPage'));

const TuitionPlansConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/tuition-plans',
			element: (
				<React.Suspense fallback={<>...</>}>
					<TuitionPlansPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default TuitionPlansConfig;
